import { useState } from 'react';
import {
  Drawer,
  DrawerTrigger,
  DrawerCloseButton,
  DrawerHeader,
  Flex,
  DrawerBody,
  DrawerFooter,
  Button,
  Text,
  Heading,
  Box,
  Dropdown,
  DropdownItem,
} from '@grupoboticario/flora-react';

import { FiFilter } from 'react-icons/fi';

import { FilterButton, StyledDrawerContent, ClearFilterButton } from './styles';

interface FilterDrawerProps {
  onApplyFilter?: (filters: any) => void;
  onClearFilter?: () => void;
  hasExpirationDate?: boolean;
  franchises?: any;
}

export function FilterDrawer({
  onApplyFilter,
  onClearFilter,
  franchises,
}: Readonly<FilterDrawerProps>) {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);

  const [selectedFranchises, setSelectedFranchises] = useState<string[]>([]);
  const [period, setPeriod] = useState('');

  const options = [
    {
      value: '2026/2027',
      label: '2026/2027',
    },
    {
      value: '2025/2026',
      label: '2025/2026',
    },
    {
      value: '2024/2025',
      label: '2024/2025',
    },
    {
      value: '2023/2024',
      label: '2023/2024',
    },
  ];

  function toggleDrawer() {
    setDrawerIsOpen(!drawerIsOpen);
  }
  function handleApplyFilter() {
    setAppliedFilterCount(0);

    onApplyFilter({
      period,
      selectedFranchises,
    });
    [period, selectedFranchises.length].forEach(applied => {
      if (applied) {
        setAppliedFilterCount(prev => prev + 1);
      }
    });

    toggleDrawer();
  }

  function handleClearFilter() {
    onClearFilter();
    setPeriod('');
    setSelectedFranchises([]);
    setAppliedFilterCount(0);

    toggleDrawer();
  }

  return (
    <Drawer open={drawerIsOpen} onOpenChange={toggleDrawer}>
      <DrawerTrigger>
        <FilterButton hierarchy="secondary" has="iconRight" icon={<FiFilter />}>
          <Text>
            Filtrar
            {appliedFilterCount > 0 && (
              <Text as="sup">{appliedFilterCount}</Text>
            )}
          </Text>
        </FilterButton>
      </DrawerTrigger>
      <StyledDrawerContent side="right">
        <DrawerHeader>
          <DrawerCloseButton />
          <Flex
            align="center"
            justify="space-between"
            css={{ marginTop: '24px' }}
          >
            <Heading level={5}>Filtrar por:</Heading>
            <ClearFilterButton
              styleSemantic="primary"
              size="bodyLargeStandardRegular"
              onClick={handleClearFilter}
            >
              Limpar filtros
            </ClearFilterButton>
          </Flex>
        </DrawerHeader>
        <DrawerBody>
          <Box>
            <Text weight="heavy">Lojas:</Text>
            <Dropdown
              id="franchises-dropdown"
              labelText="Selecione as lojas desejadas"
              optionalText=""
              value={selectedFranchises}
              onChange={event => setSelectedFranchises(event.target.value)}
              renderValue={selected => selected.join(', ')}
              multiple
            >
              {franchises?.map(franchise => (
                <DropdownItem key={franchise.code} value={franchise.code}>
                  <Text isTruncated>
                    {`${franchise.code} - ${franchise.name}`}
                  </Text>
                </DropdownItem>
              ))}
            </Dropdown>
          </Box>

          <Box>
            <Text weight="heavy" css={{ marginBottom: '8px;' }}>
              Período:
            </Text>
            <Dropdown
              id="period-dropdown"
              labelText="Selecione um período"
              optionalText=""
              value={period}
              onChange={event => setPeriod(event.target.value)}
            >
              {options?.map(periods => (
                <DropdownItem key={periods.value} value={periods.value}>
                  {periods.label}
                </DropdownItem>
              ))}
            </Dropdown>
          </Box>
        </DrawerBody>
        <DrawerFooter>
          <Flex gapX="$5">
            <DrawerCloseButton asChild>
              <Button hierarchy="secondary">Fechar</Button>
            </DrawerCloseButton>
            <Button
              size="medium"
              styleSemantic="neutral"
              onClick={handleApplyFilter}
            >
              Aplicar filtros
            </Button>
          </Flex>
        </DrawerFooter>
      </StyledDrawerContent>
    </Drawer>
  );
}
